var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 22h-.1a10.3 10.3 0 0 1-7.34-3.15 10.46 10.46 0 0 1-.26-14 10.1 10.1 0 0 1 4-2.74 1 1 0 0 1 1.06.22 1 1 0 0 1 .24 1 8.4 8.4 0 0 0 1.94 8.81 8.47 8.47 0 0 0 8.83 1.94 1 1 0 0 1 1.27 1.29A10.2 10.2 0 0 1 19.6 19a10.28 10.28 0 0 1-7.3 3M7.46 4.92a8 8 0 0 0-1.37 1.22 8.44 8.44 0 0 0 .2 11.32A8.3 8.3 0 0 0 12.22 20h.08a8.34 8.34 0 0 0 6.78-3.49A10.37 10.37 0 0 1 7.46 4.92",
    "data-name": "moon"
  }))));
};
export default SvgMoon;